<template>
  <div class="page-container">
    <div class="list">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        @click="onClickItem(item)"
      >
        <img fit="cover" :src="item.coverImage" />
        <div class="info">
          <div class="title">{{ item.title }}</div>
          <div class="desc">
            {{ item.subtitle }}
          </div>
        </div>
      </div>
    </div>
    <video
      v-show="videoShow"
      ref="videoPlayer"
      class="video-container"
      @fullscreenchange="onVideoFullScreenChange"
    />
  </div>
</template>

<script>
function buildFullUrl (url) {
  return 'https://sxbwygzh.oss-cn-beijing.aliyuncs.com/bjs' + url
}

export default {
  name: 'BjsIndex',
  data () {
    return {
      list: [
        {
          id: 1,
          title: '展览概述',
          coverImage: buildFullUrl('/images/1.jpg'),
          videoSrc: buildFullUrl('/videos/1.mp4'),
          subtitle: ''
        },
        {
          id: 2,
          title: '艾格阿多尔茨',
          coverImage: buildFullUrl('/images/2.jpg'),
          videoSrc: buildFullUrl('/videos/2.mp4'),
          subtitle: 'Simon Busom'
        },
        {
          id: 3,
          title: '伊比沙岛的女人',
          coverImage: buildFullUrl('/images/3.jpg'),
          videoSrc: buildFullUrl('/videos/3.mp4'),
          subtitle: 'Gabriel Casarrubios Martín'
        },
        {
          id: 4,
          title: '捕鱼的分类',
          coverImage: buildFullUrl('/images/4.jpg'),
          videoSrc: buildFullUrl('/videos/4.mp4'),
          subtitle: 'Gabriel Casarrubios Martín'
        },
        {
          id: 5,
          title: '卡达克斯',
          coverImage: buildFullUrl('/images/5.jpg'),
          videoSrc: buildFullUrl('/videos/5.mp4'),
          subtitle: 'Rafael Duran Benet'
        },
        {
          id: 6,
          title: '海边静物',
          coverImage: buildFullUrl('/images/6.jpg'),
          videoSrc: buildFullUrl('/videos/6.mp4'),
          subtitle: 'Carmen Espel'
        },
        {
          id: 7,
          title: '斗牛士',
          coverImage: buildFullUrl('/images/7.jpg'),
          videoSrc: buildFullUrl('/videos/7.mp4'),
          subtitle: 'Jose Maria Tuser Vazquez'
        },
        {
          id: 8,
          title: '美丽的加泰罗尼亚女人',
          coverImage: buildFullUrl('/images/8.jpg'),
          videoSrc: buildFullUrl('/videos/8.mp4'),
          subtitle: 'Roser Vinardell'
        },
        {
          id: 9,
          title: '女人的肖像',
          coverImage: buildFullUrl('/images/9.jpg'),
          videoSrc: buildFullUrl('/videos/9.mp4'),
          subtitle: 'Jose Puyettif'
        },
        {
          id: 10,
          title: '女人与吉他',
          coverImage: buildFullUrl('/images/10.jpg'),
          videoSrc: buildFullUrl('/videos/10.mp4'),
          subtitle: 'Jordi Curos'
        },
        {
          id: 11,
          title: '母亲和女儿',
          coverImage: buildFullUrl('/images/11.jpg'),
          videoSrc: buildFullUrl('/videos/11.mp4'),
          subtitle: 'Rafael Duran Benet'
        },
        {
          id: 12,
          title: '蓝眼睛的女人',
          coverImage: buildFullUrl('/images/12.jpg'),
          videoSrc: buildFullUrl('/videos/12.mp4'),
          subtitle: 'Pablo Picasso'
        },
        {
          id: 13,
          title: '举起手臂的裸体',
          coverImage: buildFullUrl('/images/13.jpg'),
          videoSrc: buildFullUrl('/videos/13.mp4'),
          subtitle: 'Pablo Picasso'
        },
        {
          id: 14,
          title: '切弗雷斯',
          coverImage: buildFullUrl('/images/14.jpg'),
          videoSrc: buildFullUrl('/videos/14.mp4'),
          subtitle: 'Augustin Ubeda'
        },
        {
          id: 15,
          title: '书蝇叶插图',
          coverImage: buildFullUrl('/images/15.jpg'),
          videoSrc: buildFullUrl('/videos/15.mp4'),
          subtitle: 'Salvador Dali'
        },
        {
          id: 16,
          title: '长颈鹿的维纳斯',
          coverImage: buildFullUrl('/images/16.jpg'),
          videoSrc: buildFullUrl('/videos/16.mp4'),
          subtitle: 'Salvador Dali'
        },
      ],
      videoShow: false
    }
  },
  methods: {
    async onClickItem (item) {
      this.videoShow = true

      await this.$nextTick()

      const video = this.$refs.videoPlayer
      video.src = item.videoSrc
      video.currentTime = 0

      await video.play()
      video.controls = true

      setTimeout(() => {
        video.requestFullscreen()
      }, 500)
    },
    onVideoFullScreenChange () {
      if (!document.fullscreenElement) {
        this.$refs.videoPlayer.pause()
        this.videoShow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
